import script from "./DetachedNoteButton.vue?vue&type=script&setup=true&lang=js"
export * from "./DetachedNoteButton.vue?vue&type=script&setup=true&lang=js"

import "./DetachedNoteButton.vue?vue&type=style&index=0&id=4f395de8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f395de8"]])

export default __exports__